<ngx-ui-loader [loaderId]="'zoneLoader'"></ngx-ui-loader>
<mat-toolbar color="primary" class="flex-row items-center">
  {{ "scheduler.setup.zones-map.title" | translate }}

  <span class="flex-spacer"></span>
  @if (addMode) {
    <button
      (click)="undoLastPoint()"
      class="button-margin-right"
      mat-icon-button
      aria-label="Undo last point"
    >
      <mat-icon fontIcon="fa-undo" fontSet="fas"></mat-icon>
    </button>
  }

  <button
    (click)="openPostcodeLookup()"
    [disabled]="addMode"
    class="button-margin-right"
    mat-stroked-button
    aria-label="Check postcode zone"
  >
    <mat-icon fontIcon="fa-magnifying-glass-location" fontSet="fas"></mat-icon>
    <span>{{ "scheduler.setup.zone.postcode-lookup.button" | translate }}</span>
  </button>

  <button
    (click)="addZone()"
    [disabled]="addMode || editMode"
    class="button-margin-right"
    color="accent"
    mat-raised-button
    aria-label="Add new zone"
  >
    @if (addMode) {
      <span>{{ "scheduler.setup.zones.drawingNew" | translate }}</span>
    }
    @if (!addMode) {
      <span>{{ "scheduler.setup.zones.new" | translate }}</span>
    }
  </button>
</mat-toolbar>

@if (isAdmin && !isLoading && !isError) {
  <button
    (click)="addZoneDialog()"
    class="primary-fab-button"
    mat-fab
    aria-label="Open zone creation dialog"
  >
    <mat-icon fontIcon="fa-plus" fontSet="fas"></mat-icon>
  </button>
}

<div class="map" id="map"></div>
